module.exports = __webpack_public_path__ + "img/clicklogo.504fa7d3.jpg";